import { gql } from 'apollo-angular';

export const WalletFragmentDoc = gql`
  fragment Wallet on Wallet {
    id
    value
}
`;

export const GetWalletByEmployeeIdDocument = gql`
  query GetWalletByEmployeeId($employeeId: String!) {
    getWalletByEmployeeId(employeeId: $employeeId) {
      ...Wallet
    }
  }
  ${WalletFragmentDoc}
`;

export const GetMyWalletDocument = gql`
  query GetMyWallet {
    getMyWallet {
      ...Wallet
    }
  }
  ${WalletFragmentDoc}
`;
